
import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0f172a] text-gray-400 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="mb-8">
              <Logo className="h-9 md:h-10 max-w-[200px]" />
            </div>
            <p className="text-gray-400 max-w-sm leading-relaxed text-[15px] mb-8">
              블루테라는 기후위기 대응을 위한 혁신적인 IT 솔루션을 통해 
              탄소중립 사회로의 전환을 선도하는 대한민국 대표 기후테크 파트너입니다.
            </p>
          </div>
          
          <div className="md:col-span-2">
            <h3 className="text-white font-black text-lg mb-8">주요 서비스</h3>
            <ul className="space-y-4 text-sm font-medium">
              <li><a href="#/solutions" className="hover:text-btOrange transition-colors">태양광 통합 지원</a></li>
              <li><a href="#/solutions" className="hover:text-btOrange transition-colors">주민참여형 발전</a></li>
              <li><a href="#/solutions" className="hover:text-btOrange transition-colors">자전거 마일리지</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-white font-black text-lg mb-8">회사 정보</h3>
            <ul className="space-y-4 text-sm font-medium">
              <li><a href="#/about" className="hover:text-btOrange transition-colors">회사소개</a></li>
              <li><a href="#/contact" className="hover:text-btOrange transition-colors">인재채용</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-white font-black text-lg mb-8">고객센터</h3>
            <ul className="space-y-5 text-sm font-medium">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-btBlue shrink-0" />
                <span>contact@blueterra.kr</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-btBlue shrink-0" />
                <span>070-7637-5678 (09:00 - 18:00)</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-btBlue shrink-0" />
                <span>경북 구미시 대학로 61, <br />두레관 302-16호(양호동, 금오공과대학교)</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-bold tracking-wider">
          <p className="opacity-50 uppercase">© {new Date().getFullYear()} BlueTerra Inc. All rights reserved.</p>
          <div className="flex gap-8 opacity-70">
            <a href="#" className="hover:text-white transition-colors">이용약관</a>
            <a href="#" className="hover:text-white transition-colors">이메일무단수집거부</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
